import { create } from 'zustand';

const useLoginRefresh = create<{ refresh: boolean; toggle: () => void }>((set, get) => ({
  refresh: false,
  toggle: () => set({ refresh: !get().refresh }),
}));

export { useLoginRefresh };
